import React, {useState,useEffect} from 'react';
import SouhoolaLib from './souhoola-lib';
import souhoolaLogo from "../../../../statics/img/souhoola/souhoola.png"

import { checkData,tenureInquiry,changeInstallment,installmentReview, confirmInstallment,confirmTransaction, resendOtp } from './Services';
import {checkProductData, productTenureInquiry, productChangeInstallment, productInstallmentReview,productConfirmInstallment, productConfirmTransaction, productResendOtp} from "./Services/product"

function Souhoola(props) {
  const [loading, setLoading] = useState(false);
  const [downPayment, setDownPayment] = useState(0);
  //const { token, integration_id } = useSelector((state: any) => state.payment);
  const [token, setToken] = useState("");
  const [integration_id, setIntegrationId] = useState("");
  const [amount, setAmount] = useState("");
  const [planDetails, setPlanDetails] = useState({installment_plans:[]});
  const [step, setStep] = useState(1);
  const [souhoolaToken, setSouhoolaToken] = useState('');
  const [souhoolaPaymentToken, setSouhoolaPaymentToken] = useState('');
  const [pmk, setPMK] = useState('');
  const [tenureRef, setTenureRef] = useState('');
  const [souhoolaTID, setSouhoolaTID] = useState('');


  const [reference, setReference] = useState('');
  const [transactionId, setTransactionId] = useState('');
  const [chosenInstallment, setChosenInstallment]= useState({month:0,installment:0,adminFees:0,downPayment:0, amount:0});

useEffect(()=>{
  console.log("props",props.userData);
  if(props.type ==="invoice"){
  setAmount(props.userData['order_amount_cents']);
  setToken(props.userData['token']);
  setIntegrationId(props.userData.integration_ids['SOUHOOLAV2']);
  setSouhoolaToken(props.userData['souhoolav2_payment_key']);
  }
  else if(props.type==="product"){
    setAmount(props.userData.product['amount_cents']);
    setToken(props.userData['token']);
    setIntegrationId(props.userData.integrations['SOUHOOLAV2']);
    setSouhoolaToken(props.userData['souhoolav2_payment_key']);
  }

},[]);

  const handleInfoSubmit = async (data) => {
    setLoading(true);
    if(props.type=== "invoice"){
      const res = await checkData(
        souhoolaToken,
        data.phone,
        data.pinCode,
        integration_id,
        amount
      );
      if (res.status === 200) {
        setStep(2);
        setSouhoolaToken(res.data.Response['souhoolav2_payment_key']);
        setSouhoolaPaymentToken(res.data.Response['token']);
        const tenureResult = await tenureInquiry(token,0,res.data.Response.token,integration_id);
        const changeInstallmentDetails = await changeInstallment(tenureResult.data.reference,0,tenureResult.data.pmk );
        setPMK(tenureResult.data.pmk);
        setTenureRef(tenureResult.data.reference);
        setPlanDetails(changeInstallmentDetails.data);
        setTransactionId(changeInstallmentDetails.data['trx_id']);  
        console.log("changeInstallmentDetails",changeInstallmentDetails.data);
        } else if (res.status === 400) {
          console.log("Something happened, please try again later");
          setLoading(false);
          return res ;
      } else {
        console.log("Something happened, please try again later");
        setLoading(false);
        return res ;
            }
      setLoading(false);
    }
    else if (props.type==="product"){
      const res = await checkProductData(
        token,
        data.phone,
        data.pinCode,
        integration_id,
        amount
      );
      if (res.status === 200) {
        setStep(2);
        setSouhoolaToken(res.data.Response['souhoolav2_payment_key']);
        setSouhoolaPaymentToken(res.data.Response['token']);
        console.log('userData', props.userData,"deliveryData", props.deliveryData);
        const tenureResult = await productTenureInquiry(token,0,res.data.Response.token,integration_id,props.deliveryNeed ,props.deliveryData,props.userData,amount);
        const changeInstallmentDetails = await productChangeInstallment(tenureResult.data.reference,0,tenureResult.data.pmk );
        setPMK(tenureResult.data.pmk);
        setTenureRef(tenureResult.data.reference);
        setPlanDetails(changeInstallmentDetails.data);
        setTransactionId(changeInstallmentDetails.data['trx_id']);  
        console.log("changeInstallmentDetails",changeInstallmentDetails.data);
      } else if (res.status === 400) {
        setLoading(false);
        return res ;
      } else {
        setLoading(false);
        return res ;
      }
      setLoading(false);
    }
  
  };
  const goToconfirmInstallment = async()=>{
    setLoading(true);
    if(props.type ==="invoice"){
      const installmentReviewData = await installmentReview(pmk,chosenInstallment.month,downPayment,tenureRef, (amount/100));
      if(installmentReviewData.status === 200){
        setSouhoolaTID(installmentReviewData.data.Response['souhoolaTID'].toString());
       setStep(3);
    }
  }
    else if (props.type ==="product"){
      const installmentReviewData = await installmentReview(pmk,chosenInstallment.month,downPayment,tenureRef, (amount/100));
      if(installmentReviewData.status === 200){
        setSouhoolaTID(installmentReviewData.data.Response['souhoolaTID'].toString());
       setStep(3);
      
    }

   }
   setLoading(false);
  }

  const handleInstallmentChange = async(data)=>{
    setLoading(true);
    await setChosenInstallment({...data, amount:amount});
    setLoading(false);
    console.log("change",data);
  }
  const handleConfirmInstallment = async()=>{
    setLoading(true);
    if (props.type ==="invoice"){
      await confirmInstallment(pmk,souhoolaTID,tenureRef);
    }
    else if (props.type ==="product"){
      await productConfirmInstallment(pmk,souhoolaTID,tenureRef);
    }
    setLoading(false);
    setStep(4);
  }
  const handleConfirmTransaction = async(otp)=>{
    setLoading(true);
    if (props.type ==="invoice"){
      const res  = await confirmTransaction(otp,pmk,transactionId);
      if (res.status === 200) {
        props.setReqComplete({head: 'Transaction successful', body:'Thank you for using the online payment service.'});
      }
      else if (res.status === 400){
        setLoading(false);
        return res;

      }
      else{
        setLoading(false);
        return res;


      }
    }
  else if (props.type ==="product"){
    const res  = await productConfirmTransaction(otp,pmk,transactionId);
    if (res.status === 200) {
      props.setReqComplete({head: 'Transaction successful', body:'Thank you for using the online payment service.'});
    }
    else if (res.status === 400){
      setLoading(false);
      return res;
    }
    else{
      setLoading(false);
      return res;
    }
  }
    setLoading(false);
  }
  const handleResendOtp = async()=>{
    setLoading(true);
    if(props.type==="invoice"){
      const res = await resendOtp(pmk,tenureRef);
      setLoading(false);
      return res;
    }
    else if (props.type ==="product"){
      const res = await productResendOtp(pmk,tenureRef);
      setLoading(false);
      return res;
    }
  }
  const handleDownPaymentChange = async (data)=>{
    setLoading(true);
    if(data< amount){
      setDownPayment(data);
      if(props.type ==="invoice"){
        const changeInstallmentDetails = await changeInstallment(tenureRef,data,pmk);
        setPlanDetails(changeInstallmentDetails.data);
      }
      else if (props.type ==="product"){
        const changeInstallmentDetails = await productChangeInstallment(tenureRef,data,pmk);
        setPlanDetails(changeInstallmentDetails.data);
      }
  
    }
    setLoading(false);
  }
  return (
    <div style={{textAlign:"center"}}>
  <div className='title'>
      <img
        className='title-icon'
        src={souhoolaLogo}
        alt="souhoola logo"
        width="250px"
        style={{marginBottom:20}}
      />
    </div>
  <SouhoolaLib
      step={step}
      loading={loading}
      plans={planDetails.installment_plans}
      installmentSummary={chosenInstallment}
      handleInfoSubmit={handleInfoSubmit}
      handleDownPaymentChange={handleDownPaymentChange}
      handleConfirmInstallment={handleConfirmInstallment}
      handleConfirmTransaction={handleConfirmTransaction}
      handleInstallmentChange={handleInstallmentChange}
      handleResendOtp={handleResendOtp}
      goToconfirmInstallment={goToconfirmInstallment}
      chosenInstallment={chosenInstallment}
      downPayment ={downPayment}
      amount ={amount/100}
      /> 
    </div>
  );
  }
  export default Souhoola;